module.exports = __webpack_public_path__ + "img/1.547e9e31.png";